<template>
    <div class="bd">
        <div class="header">
            <img :src="detail.imgurl" />
        </div>
        <div class="tabs">
            <div class="tab" @click="golive">
                <div>直播教学</div>
                <div class="btn">立即学习</div>
            </div>
            <div class="tab2">
                <div class="item" v-for="(item,index) in list" :key="item.id" @click="go(item,index+1)">
                    <div :class="['icon'+index]"></div>
                    <div>{{item.title}}</div>
                </div>
            </div>
        </div>
        <div class="match">
            <div class="title">线下活动</div>

            <List  v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
                <div class="list">
                    <div class="item" v-for="item in matchlist" :key="item.id" @click="godetail(item)">
                        <img :src="item.imgurl" />
                        <div class="con">
                            <div>{{item.title}}</div>
                            <div>
                                <div class="status" :style="{background: item.statecolor }">{{item.statename}}</div>
                                <div class="time">活动时间：{{item.starttime}}-{{item.endtime}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </List>
        </div>
    </div>
</template>

<script>
import {
		List
	} from "vant";
export default {
    data() {
        return {
            detail: {},
            list:[],
            matchlist: [],
            loading: false,
            finished: false,
            page: 1
        }
    },
    components: {List},
    mounted() {
        this.$nextTick(() => {
            this.init();
            // this.getList()
        });
    },
    methods: {
        init() {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
                duration: 0, // 持续展示 toast
            });
            this.$api.sports.sportsMain(this.$route.params.sportsid).then(
                (res) => {
                    this.detail = res.data.items[0]
                    this.list = res.data.items
                    if (window.__wxjs_is_wkwebview) {
                        //部分ios
                        window.scrollTo(0, 1);
                    }
                    this.$toast.clear();
                },
                (e) => {
                    this.$toast.clear();
                }
            );
        },
        getList()
        {
            this.$api.common.getMatchList({categoryid: 6,app: 19, page: this.page}).then(res=>{
                let {
                    page,
                    pages,
                    list
                } = res.data;

                this.loading = false;
                if (page === 1) {
                    this.matchlist = list;
                } else {
                    this.matchlist = this.matchlist.concat(list);
                }

                if (page>= pages) {
                    this.finished = true;
                } else {
                    this.page++;
                }
            })
        },
        golive() {
            this.$router.push({name:'live',params: {subid: 999}})
        },
        go(item,type) {
            this.$router.push({name:'item',params: {itemid: item.id,type:type}})
        },
        godetail(item) {
            if(item.jump_url != '' && item.jump_url.indexOf('https') !== -1) {
                window.location.replace(item.jump_url)
                return
            } else {
                wx.miniProgram.navigateTo({
                    url: `/pages/match/detail/index?matchid=${item.id}`
                })
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>